module.exports = __webpack_public_path__ + "static/media/mobile.bb0df83b.png";